import { useEffect, useState } from "react";
import AuiButton from "../../components/Buttons/Buttons";
import MoreOption from "../../components/MoreOptions/MoreOption";
import AuiIcon from "../../components/AuiDropdown/AuiIcon";
import {
  getCertificate,
  CertificateListParams,
} from "../../services/training-session.service";
import { useDispatch } from "react-redux";
import { showAlert } from "../../store/alertSlice";
import AuiPrimaryPagination from "../../components/AuiDropdown/AuiPagination";
import CertificateFilterSection, {
  DropdownOption,
} from "../../components/Filters/CertificateFilterSection";
import noRecord from "../../assets/images/no-recs.png";
import { useNavigate } from "react-router-dom";
import Headings from "../../components/Headings/Headings";

const CerificateListing = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [certificateList, setCertificateList] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pagination, setPagination] = useState({
    isFirst: true,
    isLast: false,
    pageNumber: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
    rowsperpage: 10,
  });
  const [certType, setCertType] = useState<DropdownOption | null>(null);
  const [orgName, setOrgName] = useState<DropdownOption | null>(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getCertificateTemplate = async () => {
    setIsLoading(true);
    setCertificateList([]);
    try {
      const params: CertificateListParams = {
        certificateType: certType?.name.toLowerCase(),
        organisationId: orgName?.id,
        pageNumber: currentPage,
        pageSize: pageSize,
      };

      const result = await getCertificate(params);
      if (!result || result.status !== 200) {
        dispatch(
          showAlert({
            message: "Failed to fetch certificate template",
            type: "error",
          })
        );
      } else {
        const certificateData = result?.data?.certificate || [];
        setCertificateList(certificateData);
        setPagination({
          isFirst: !!result?._pagination?.isFirst,
          isLast: result?._pagination?.isLast || false,
          totalItems: result?._pagination?.totalCount || 0,
          totalPages: result?._pagination?.totalPages || 0,
          pageNumber: result?._pagination?.pageNumber || 1,
          pageSize: result?._pagination?.pageSize || 10,
          rowsperpage: result?._pagination?.pageSize || 10,
        });
      }
    } catch (error) {
      console.error("Error fetching certificate:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCertificateTemplate();
  }, [currentPage, pageSize, certType, orgName]);

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setCurrentPage(1);
  };

  const handleViewClick = (id: number) => {
    navigate(`/edit-certificate/${id}`);
  };

  return (
    <div className="CertificateMainSection container my-4">
      <div className="border-bottom">
        <div className="row d-flex align-items-center my-3">
          <div className="col-12">
            <Headings size="h1" className="mb-0">
              Certificate List
            </Headings>
          </div>
        </div>
      </div>
      <CertificateFilterSection
        setCertType={setCertType}
        setOrgName={setOrgName}
        setCurrentPage={setCurrentPage}
      ></CertificateFilterSection>
      <div>
        {isLoading && (
          <div className="aui-loader loaderHeight">
            <aui-loader type="content"></aui-loader>
          </div>
        )}
        {!isLoading &&
          (certificateList.length > 0 ? (
            <div className="certListingTable">
              <aui-table
                type="status"
                headerbackground={true}
                headerborder={true}
              >
                <table>
                  <thead>
                    <tr>
                      <th scope="col">
                        <div className="aui-th font-600">Name</div>
                      </th>
                      <th scope="col">
                        <div className="aui-th font-600">Certificate Type</div>
                      </th>
                      <th scope="col">
                        <div className="aui-th font-600">Organisation Name</div>
                      </th>
                      <th scope="col">
                        <div className="aui-th d-flex justify-content-lg-center pl-3 font-600">
                          Actions
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {certificateList.map((cert) => (
                      <tr key={cert.id} className="aui-tr-normal orgTableRow">
                        <td data-title="Name">
                          <div className="aui-td">{cert.name}</div>
                        </td>
                        <td data-title="Type">
                          <div className="aui-td">{cert.certificateType}</div>
                        </td>
                        <td data-title="OrgnisationName">
                          <div className="aui-td">{cert.orgnisationName}</div>
                        </td>
                        <td data-title="Action">
                          <div className="d-flex position-relative aui-td justify-content-lg-center">
                            <MoreOption>
                              <ul className="px-1">
                                <li>
                                  <AuiIcon
                                    iconClass="view"
                                    svgheight="15"
                                    svgwidth="15"
                                  />
                                  <AuiButton
                                    variant="button-text-styled"
                                    buttontitle="View"
                                    modalid="exampleModal"
                                    size="small"
                                    buttonid={""}
                                    buttonclass="actionBtn px-2"
                                    buttonClick={() =>
                                      handleViewClick(cert?.id)
                                    }
                                  ></AuiButton>
                                </li>
                              </ul>
                            </MoreOption>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </aui-table>
            </div>
          ) : (
            <div className="aui-status-table-emptystate aui-table-empty">
              <div className="aui-table-no-data d-flex flex-column justify-content-center align-items-center">
                <img src={noRecord} alt="No Data" />
                <h1 className="mb-0">No Data Found</h1>
              </div>
            </div>
          ))}
        {certificateList.length > 0 && (
          <section className="py-4">
            <AuiPrimaryPagination
              inputdata={pagination}
              totalitems={pagination.totalItems}
              rowsperpage={pagination.rowsperpage}
              setCurrentPage={setCurrentPage}
              setPageSize={handlePageSizeChange}
            />
          </section>
        )}
      </div>
    </div>
  );
};

export default CerificateListing;
